import { ControlTemplate } from 'dac-web-ui';
import css from './cellDivision.module.css';
import html from './cellDivision.module.hbs';
import { Toastr } from 'dac-web-ui/src/index';

export class CellDivision extends ControlTemplate {

	constructor( containerId ) {
		super();
		this.containerId = containerId;
		this._escEvent = null;
	}

	async show( init, end ) {
		return new Promise(( resolve ) => {

			this.init = init;
			this.end = end;

			//add css
			let idcss = 'cellDivision';
			
			//remove
			let old = document.head.querySelector( '#' + idcss );
			if( old ) old.parentNode.removeChild( old );

			//add
			let styleSheet = document.createElement( 'style' );
			styleSheet.id = idcss;
			styleSheet.type = 'text/css';
			styleSheet.innerText = css;

			document.head.appendChild( styleSheet );

			//add html
			this.container = document.getElementById( this.containerId );
			const item = {
				rowTitle: 'INITIAL',
				columnTitle: 'NEW',
				startTitle: 'START',
				endTitle: 'END',
				cancelTitle: 'CANCEL',
				selectTitle: 'CUT',
				init: this.init,
				end: this.end
			};
			if( this.container ) this._addHtml( this.container, item, html );
			this.#addEventHandlers( resolve );

			//focus row start
			const rowStart = document.querySelector('#CDInputStartColumn');
			rowStart.focus();
		} );
	}

	#addEventHandlers( resolve ) {
		//on cancel click
		let add = document.querySelector('#CDButtonCancel');
		add.onclick = () => this.#close(resolve, false);
		let background = document.querySelector('#CDScreen');
		background.onclick = e => {
			if( e.target.id === 'CDScreen' )
				this.#close(resolve, false);
		};

		//on cancel click
		let select = document.querySelector('#CDButtonCut');
		select.onclick = () => this.#close(resolve, true);

		const close = (resolve) => this.#close(resolve, false);

		this._escEvent = (e) => {
			if (e.key === 'Escape') close( resolve, false );
		};
		document.addEventListener( 'keydown', this._escEvent );
	}

	#close( resolve, response) {

		let result = {
			ok: response
		};

		if( response ) { 
			Object.assign( result, this.#getResult() );
			// init or start must match, can't make 3 subgroups from the current group
			if( result.newInit !== this.init && result.newEnd !== this.end ) {
				result.ok = false;
				result.message = 'Init or End must match with the previous values';
			}
			// Must mantain the same direction
			if( ( this.init > this.end && result.newInit < result.newEnd ) || ( this.init < this.end && result.newInit > result.newEnd ) ) {
				result.ok = false;
				result.message = 'Init or End must match with the previous values';
			}
			//Can't be the same values of previous values
			if( result.newInit === this.init && result.newEnd === this.end ) {
				response = false;
				result.ok = false;
			} else {
				//new values are inside the previous values and match direction and at least one of the corners (init or end)
				const min = Math.min( this.init, this.end );
				const max = Math.max( this.init, this.end );
				const newMin = Math.min( result.newInit, result.newEnd );
				const newMax = Math.max( result.newInit, result.newEnd );
				if(  newMin < min || newMax > max ) {
					result.ok = false;
					result.message = 'Init or End must be inside the previous values';
				}
			}

		}

		if( response && !result.ok ) {
			const title = 'Cell Division';
			new Toastr().warning( 'Init or End must match with the previous values', title );
			return;
		}

		//remove css
		let idcss = 'cellDivision';
		let old = document.head.querySelector( '#' + idcss );
		if( old ) old.parentNode.removeChild( old );

		//remove html
		if( this.container ) this.container.innerHTML = '';

		//remove events
		document.removeEventListener( 'keydown', this._escEvent );
		this._escEvent = null;

		resolve( result );
	}

	#getResult() {
		let result = {};
		//get start row and column
		let newInit, newEnd;
		try {
			newInit = parseInt( document.querySelector('#CDInputStartColumn').value );
		} catch( e ) { newInit = -1; }
		try {
			newEnd = parseInt( document.querySelector('#CDInputEndColumn').value );
		} catch( e ) { newEnd = -1; }

		result = { newInit, newEnd };

		return result;
	}
}